import { render, staticRenderFns } from "./polaris-report.vue?vue&type=template&id=89105eee&"
import script from "./polaris-report.vue?vue&type=script&lang=js&"
export * from "./polaris-report.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports